import { create } from 'zustand'

const useToastStore = create((set) => ({
  toasts: [],
  addToast: (message, type = 'info') => {
    const toast = {
      id: Date.now(),
      type: typeof message === 'object' ? message.type || type : type,
      createdAt: new Date()
    }

    if (typeof message === 'object') {
      toast.title = message.title
      toast.description = message.description
    } else {
      toast.description = message
    }

    set((state) => ({
      toasts: [...state.toasts, toast]
    }))
  },
  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter(toast => toast.id !== id)
  }))
}))

export default useToastStore 